import React, { useState, useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, downloadFile, showMessageToastCustom, isNullOrEmpty } from '../../../../../utils/util';
import InventoryService from '../../../../../services/InventoryService';
import { BackButton, Title, Subtitle, Button } from '../../../../../components/UI/ComponentsUI';

const RowHeaderReport = (props) => {
    const [location, setLocation] = useState('');
    let inputFilter;

    useEffect(() => {
        inputFilter.focus();
    }, [inputFilter]);

    const applyFilter = () => {
        if (!isNullOrEmpty(location)) {
            props.rowHeaderReport(props.filter.inventoryId, location, (response) => {
                if (response) {
                    downloadFile(response.data, response.fileName, response.type, true);
                } else {
                    showMessageToastCustom(translate('warning', 'general'), translate('no-item-found', 'inventory'), 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            });
        } else {
            M.toast({ html: translate('validations.required'), classes: 'red' });
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                    <Subtitle icon="mdi mdi-file-document-outline" label={translate('general.menu.reportDroneLine', 'inventory')} />
                </div>
            </div>
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="col s12">
                        <input
                            id="txtLocation"
                            ref={(el) => inputFilter = el}
                            placeholder={translate('location', 'inventory')}
                            type="text"
                            maxLength="20"
                            onChange={(ev) => { setLocation(ev.currentTarget.value); }}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <Button full="true" text={translate('general.generateReport')} onClick={() => applyFilter()} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        rowHeaderReport: (inventoryId, location, callback) => {
            dispatch(InventoryService.rowHeaderReport(inventoryId, location, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RowHeaderReport)));
